import { Components, Theme } from '@mui/material/styles';

export const MuiDialogContent: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(0, 16, 8, 16),
    }),
  },
};
